import axios from "axios";
import { getAccessToken , isTokenExpired } from "../okta/authService";
import eventEmitter from "../core/eventEmitter";
import { v4 as uuidv4 } from 'uuid';
import { log } from '../../util/newRelicApi';

export const toBearerAuth = (token: string) => `Bearer ${token}`;


axios.defaults.withCredentials = true

const bffInstance = axios.create({
  baseURL: "/api", // Replace with your API base URL
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: false
});

const externalInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: false
});


const bffNotificationInstance = axios.create({
  baseURL: "/notification-api", 
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
    withCredentials: false
});

const bffERInstance = axios.create({
  baseURL: "/api-er", // Replace with your API base URL
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: false
});

bffERInstance.interceptors.request.use(
  async (config:any) => {
    try {
      let url = `${config.baseURL || ""}${config.url}`;
      const isExpired = isTokenExpired();
      if(isExpired){
        return Promise.reject("Token is expired");
      }
      const token = await getAccessToken();
      const traceId = uuidv4();
      //const authState = await isAuthenticated();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers["x-trace-id"] = traceId;
      }
      const method = (config.method || "get").toUpperCase();
       log(url,method,traceId,token);
    } catch (e) {
      // Swallow logging errors so they don't break the actual request
      console.error("Logging failed in interceptor", e);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Request Interceptor (e.g., for adding auth token)
bffInstance.interceptors.request.use(
  async (config:any) => {
    try {
      let url = `${config.baseURL || ""}${config.url}`;
      const isExpired = isTokenExpired();
      if(isExpired){
        return Promise.reject("Token is expired");
      }
      const token = await getAccessToken();
      const traceId = uuidv4();
      //const authState = await isAuthenticated();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers["x-trace-id"] = traceId;
      }
      const method = (config.method || "get").toUpperCase();
       log(url,method,traceId,token);
    } catch (e) {
      // Swallow logging errors so they don't break the actual request
      console.error("Logging failed in interceptor", e);
    }
    return config;
  },
  (error) => Promise.reject(error)
);


// Request Interceptor (e.g., for adding auth token)
externalInstance.interceptors.request.use(
  async (config:any) => {
    try {
      let url = `${config.baseURL || ""}${config.url}`;
      const isExpired = isTokenExpired();
      if(isExpired){
        Promise.reject("Token is expired");
      }
      const token = await getAccessToken();
      const traceId = uuidv4();
      //const authState = await isAuthenticated();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers["x-trace-id"] = traceId;
      }
      const method = (config.method || "get").toUpperCase();
       log(url,method,traceId,token);
    } catch (e) {
      // Swallow logging errors so they don't break the actual request
      console.error("Logging failed in interceptor", e);
    }
    return config;
  },
  (error) => Promise.reject(error)
);


// Response Interceptor (e.g., for handling errors globally)
externalInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;
      if (status === 401) {
        console.warn("ExternalInstance Unauthorized request.");
      }
      if (status === 403) {
        console.warn("ExternalInstance Invalid session detected. ");
      }

      if (status === 503 || status === 504) {
        eventEmitter.emit("externalInstance", error.response);
        console.warn("ExternalInstance service is unavailable ...");
      }
    }
    console.warn("ExternalInstance service error ...");
     return Promise.reject(error);;
  }
);


// Response Interceptor (e.g., for handling errors globally)
bffInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;
      if (status === 401) {
        console.warn("Unauthorized request. Logging out ...");
      }
      if (status === 403) {
        console.warn("Invalid session detected. Logging out ...");
      }

      if (status === 503 || status === 504) {
        eventEmitter.emit("bffError", error.response);
        console.warn("Bff service is unavailable ...");
      }
    }
    console.warn("Bff service error ...");
    return Promise.reject(error);
  }
);

const oktaInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Request Interceptor (e.g., for adding auth token)
oktaInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor (e.g., for handling errors globally)
oktaInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;
      if (status === 401) {
        console.warn("Unauthorized request. Logging out ...");
      }
      if (status === 403) {
        console.warn("Invalid session detected. Logging out ...");
      }
      if (status === 404) {
        console.warn("Session not found. Logging out ...");
      }
    }
    console.error("API Error:", error.response);
    eventEmitter.emit("error", error);
    return Promise.reject(error);
  }
);

export { bffInstance, bffERInstance, oktaInstance ,bffNotificationInstance, externalInstance};
